/**
 * How long the editor waits for the import-cad job's WebSocket completion
 * event before telling the user it timed out.
 *
 * This is a fallback for a LOST notification, not a deadline for the work. The
 * job itself is bounded by the importCad Lambda's own 900s ceiling, so a
 * shorter fallback reports failure on work that is still running and about to
 * succeed — the user is told to refresh a page whose job then completes
 * normally. Add and remove both rebuild the root assembly STEP from the proto
 * before they report, which a 60s budget no longer covered.
 *
 * Kept in one place because every CAD job modal needs the same bound and they
 * must not drift.
 */
export const CAD_JOB_WS_TIMEOUT_MS = 15 * 60 * 1000;
